class DesertCustomRequest extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('input', () => this.updateValidity(), options);
    this.addEventListener('change', () => this.updateValidity(), options);
    this.updateValidity();
  }
  disconnectedCallback() { this.controller?.abort(); }
  updateValidity() {
    const image = this.querySelector('[data-design-image]');
    const text = this.querySelector('[data-design-text]');
    const placement = this.querySelector('[data-design-placement]');
    if (!image || !text || !placement) return;
    const file = image.files?.[0];
    text.setCustomValidity(!file && !text.value.trim() ? this.dataset.missing : '');
    image.setCustomValidity(file && file.size > 5 * 1024 * 1024 ? this.dataset.fileSize : file && !['image/jpeg','image/png','image/webp','image/gif'].includes(file.type) ? this.dataset.fileType : '');
    placement.setCustomValidity(placement.value && !placement.value.trim() ? this.dataset.placementMissing : '');
  }
  validate() {
    this.updateValidity();
    return this.closest('form')?.reportValidity() ?? false;
  }
}
if (!customElements.get('desert-custom-request')) customElements.define('desert-custom-request', DesertCustomRequest);
